/**
 * Models
 */
export const ProductionMachineType = (json: IProductionMachineType): IProductionMachineTypeModel => {
	const { id, uuid, name, description, product_types, is_active, created_at, updated_at } = json

	return {
		id,
		uuid,
		name,
		description,
		isActive: is_active,
		productTypes: product_types ? product_types.map(ProductionProductType) : [],
		createdAt: created_at ? new Date(created_at) : null,
		updatedAt: updated_at ? new Date(updated_at) : null,
	}
}

/**
 * Payloads
 */
export const ProductionMachineTypeToCreatePayload = (
	model: IProductionMachineTypeManageForm,
): IProductionMachineTypeCreatePayload => {
	const { name, description, productTypesIds } = model

	return {
		name,
		description,
		product_type_ids: productTypesIds.map(value => value.value),
	}
}

export const ProductionMachineTypeToUpdatePayload = (
	updated: IProductionMachineTypeModel,
	model: IProductionMachineTypeManageForm,
): IProductionMachineTypeUpdatePayload => {
	const { name, description, productTypesIds } = model

	return {
		id: updated.id,
		product_type_ids: productTypesIds.map(value => value.value),
		name,
		description,
	}
}
